export class FlexGallery {
    private static readonly maxHeight: number = 600;
    private static readonly gapSize: number = 20;
    private static readonly delay: number = 150;

    public onUpdate?: () => Promise<void>;

    private currentWidth = 0;
    private rowChilds: HTMLElement[] = [];

    public async refresh(): Promise<void> {
        const wrapper = document.querySelector<HTMLElement>('.posts');

        if (!wrapper) {
            return;
        }

        const maxWidth = wrapper.clientWidth;
        const posts = document.querySelectorAll<HTMLElement>('.posts > .post');

        for (const post of posts) {
            let image = post.querySelector('img');

            if (!image) {
                return;
            }

            image = await this.loadImage(image.src);

            const width = image.naturalWidth;
            const height = image.naturalHeight;
            const ratio = this.getRatio(width, height);
            const newWidth = this.getWidth(FlexGallery.maxHeight, ratio);

            post.style.flexBasis = '0';
            post.style.flexGrow = newWidth.toString(10);
            post.style.flexShrink = newWidth.toString(10);
            post.style.maxWidth = `${newWidth.toString(10)}px`;

            if (this.currentWidth > 0) {
                this.currentWidth += FlexGallery.gapSize;
            }

            this.currentWidth += newWidth;
            this.rowChilds.push(post);

            if (this.currentWidth >= maxWidth) {
                this.createRow(wrapper, this.rowChilds);
                this.rowChilds = [];
                this.currentWidth = 0;
            }
        }

        this.createRow(wrapper, this.rowChilds);

        if (this.onUpdate) {
            await this.onUpdate();
        }
    }

    private async loadImage(postImageThumbnail: string): Promise<HTMLImageElement> {
        return new Promise((resolve): void => {
            const tmpImage = new Image();

            tmpImage.onload = (): void => {
                resolve(tmpImage);
            };

            tmpImage.src = postImageThumbnail;
        });
    }

    private createRow(wrapper: HTMLElement, rowChilds: HTMLElement[]): void {
        const row = document.createElement('div');

        row.classList.add('posts-row');

        let i = 0;

        for (const rowChild of rowChilds) {
            row.appendChild(rowChild);
            rowChild.dataset.aos = 'zoom-in';
            rowChild.dataset.aosDelay = (i * FlexGallery.delay).toString(10);
            i++;
        }

        wrapper.appendChild(row);
    }

    private getRatio(width: number, height: number): number {
        return width / height;
    }

    private getWidth(height: number, ratio: number): number {
        return height * ratio;
    }
}
